/**
 * Background: Channel Steering have two Email containers
 * Util Email functions set
 */

import classNames from 'classnames';

export const validEmailType = ['textarea', 'text', 'date', 'number', 'select'];

// Validate Email webform; check input options
function isValidatedSubmitForm(fields) {
  if (Array.isArray(fields) && fields.length > 0) {
    const validateFields = fields.some((field) => (
      validEmailType.includes(field.type)
    ));
    return validateFields;
  }
  return false;
}

// Hide the submit button, if there is no input area
export function hideSubmitButton(fields) {
  return classNames({
    'hide-submit-btn': !isValidatedSubmitForm(fields),
  });
}

// Logout Email form access query
export const logoutEmailQuery = 'email';

// Initial Email form validation
const isRequiredField = (field = {}) => field.required && validEmailType.indexOf(field.type) >= 0;

/**
 * `setFieldsDetail` helps to create the new array with customized Field Structure.
 * @param {String} fieldPrefix  This is Topic Id which is last selected.
 * @param {Array} fieldsDetial This Custom Object hold the required field details.
 */
export const setFieldsDetail = (fieldPrefix, fieldsDetial) => {
  const fields = fieldsDetial.map((field, index) => {
    const fieldType = `${field.type || 'unnamed-type'}`;
    const fieldId = field.id || `${fieldType}-${fieldPrefix}-${index + 1}`;

    const fieldInfo = {
      id: fieldId,
      type: field.type,
      label: field.default_text,
      name: field.ref_id || field.id || field.default_text || field.type,
      isRequired: isRequiredField(field),
      value: '',
      hasError: (isRequiredField(field)),
    };

    if (field.character_limit) {
      fieldInfo.limit = field.character_limit;
    }

    if (field.url_validation) {
      fieldInfo.urlValidation = field.url_validation;
    }

    if (field.options) {
      fieldInfo.options = field.options.map((value) => ({
        value,
        label: value,
      }));
    }

    if (field.link_src) {
      fieldInfo.href = field.link_src;
    }

    if (field.title) {
      fieldInfo.title = field.title;
    }

    if (field.depends_on_id) {
      fieldInfo.dependsOnId = field.depends_on_id;
    }

    // Validate the dependency field value; have dependency with depends_on_id attribute
    if (field.depends_on_value) {
      fieldInfo.dependsOnValue = field.depends_on_value;
    }
    return fieldInfo;
  });
  return fields;
};
